import { Component } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import { BiMessageSquareDetail } from "react-icons/bi";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./nav.css";

class Nav extends Component {
  constructor() {
    super();
    this.state = { active: "#" };
  }

  handleNavClick = (e, href) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ active: href });

    // Disable ScrollTrigger during navigation
    try {
      if (ScrollTrigger && typeof ScrollTrigger.disable === "function") {
        ScrollTrigger.disable();
      }
    } catch (err) {
      // ignore if not available
    }

    if (href === "#") {
      // Scroll to top for home
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Scroll to section
      const target = document.querySelector(href);
      if (target) {
        const targetPosition =
          target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: Math.round(targetPosition),
          behavior: "smooth",
        });
      }
    }

    // Re-enable ScrollTrigger after smooth scroll completes
    const REENABLE_MS = 900;
    setTimeout(() => {
      try {
        if (ScrollTrigger && typeof ScrollTrigger.enable === "function") {
          ScrollTrigger.enable();
          ScrollTrigger.refresh();
        }
      } catch (err) {
        // ignore
      }
    }, REENABLE_MS);
  };

  render() {
    return (
      <nav>
        <a
          onClick={(e) => this.handleNavClick(e, "#")}
          className={this.state.active === "#" ? "active" : ""}
          href="#"
        >
          <AiOutlineHome />
        </a>
        <a
          onClick={(e) => this.handleNavClick(e, "#about")}
          className={this.state.active === "#about" ? "active" : ""}
          href="#about"
        >
          <AiOutlineUser />
        </a>
        <a
          onClick={(e) => this.handleNavClick(e, "#services")}
          className={this.state.active === "#services" ? "active" : ""}
          href="#services"
        >
          <RiServiceLine />
        </a>
        <a
          onClick={(e) => this.handleNavClick(e, "#testimonials")}
          className={this.state.active === "#testimonials" ? "active" : ""}
          href="#testimonials"
        >
          <BiBook />
        </a>
      </nav>
    );
  }
}

export default Nav;
